import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import { Button } from "../../../myfin_v2/elements/Button";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import standaloneCss from "../../../myfin_v2/css/standalone.module.css";

import { useState, useEffect, useRef } from "react";
import ConsolDropdown from "../../../myfin_v2/elements/ConsolDropdown";
import ChipsGroup from "../../../myfin_v2/elements/ChipsGroup";
import { getManualRelatedPartyDetailsApiHandler, setManualRelatedPartyDetailsApiHandler } from "../ApiServices/apiHandler";

const AddRPTTransactionModal = ({ setShowAddRPTTransactionModal }) => {
  const project_id = localStorage.getItem("project_id");

  const [relatedParties, setRelatedParties] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allOutsatandingBalance, setAllOutsatandingBalance] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedOutstandingBalance, setSelectedOutstandingBalance] = useState(
    [],
  );
  const [selRelatedParty, setSelRelatedParty] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  useEffect(() => {
    getManualRelatedPartyDetails();
  }, []);

  const getManualRelatedPartyDetails = () => {
    const getParams = {
      projectID: project_id,
    };
    getManualRelatedPartyDetailsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          setRelatedParties(response?.data?.relatedPartyNameList ?? []);
          setAllTransactions(response?.data?.transactionList ?? []);
          setAllOutsatandingBalance(
            response?.data?.outstandingBalanceList ?? [],
          );
        } else {
          swal(
            "Error",
            response?.data?.error ||
              "Unable to get manual related party details",
            "error",
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error ||
            "Unable to populate manual related party details",
          "error",
        );
      });
  };

  const handleSave = () => {
    const payload = {
      relatedPartyName: selRelatedParty,
      transaction: selectedTransactions,
      outstandingBalance: selectedOutstandingBalance,
    };

    setManualRelatedPartyDetailsApiHandler({ projectID: project_id }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          setShowAddRPTTransactionModal(false);
          swal("Related Party added successful", "", "success");
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to add Related Party",
            "error",
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to add Related Party",
          "error",
        );
      });

  };

  return (
    <>
      <Modal
        title={"Add Related Party"}
        width="35%"
        headerActions={
          <CloseIcon
            onClick={() => {
              setShowAddRPTTransactionModal(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setShowAddRPTTransactionModal(false);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Proceed"
              onClick={() => {
                handleSave();
              }}
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div style={{ width: "95%", placeSelf: "center" }}>
          <InputGroup
            label="Related Party Name"
            inputs={[
              <div 
                ref={dropdownContainerRef}
                onClickCapture={() => setIsDropdownOpen(true)}
                style={{ width: "100%" }}
              >
                <ConsolDropdown
                  isEditable={true}
                  options={relatedParties.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  onSelect={(sel) => {
                    setSelRelatedParty(sel ? sel.value : null);
                    setIsDropdownOpen(false);
                  }}
                  placeHolder="Select Related Party Name"
                  selected={{ label: selRelatedParty || "", value: selRelatedParty || "" }}
                />
              </div>,
            ]}
          />

          {isDropdownOpen && <div style={{ height: "150px" }} />}

          {/* TRANSACTIONS */}
          <ChipsGroup
            title="Transaction"
            items={allTransactions}
            selectedItems={selectedTransactions}
            onChange={setSelectedTransactions}
            allowCustomInput={true}
            customInputLabel="Other Transactions"
            customInputPlaceholder="Enter Other Transactions"
          />

          {/* OUTSTANDING BALANCE */}
          <ChipsGroup
            title="Outstanding Balance"
            items={allOutsatandingBalance}
            selectedItems={selectedOutstandingBalance}
            onChange={setSelectedOutstandingBalance}
            allowCustomInput={true}
            customInputLabel="Other Outstanding Balance"
            customInputPlaceholder="Enter Other Outstanding Balance"
          />
        </div>
      </Modal>
    </>
  );
};

export default AddRPTTransactionModal;
